import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FA_ICONS } from './fa-icons';

/** namespace ของไอคอน Font Awesome: ใช้เป็น svgIcon="fa:ชื่อไอคอน" */
export const FA_NAMESPACE = 'fa';

/** ลงทะเบียนไอคอน Font Awesome (SVG ที่ดึงจาก dentapop) กับ MatIconRegistry ตอนเริ่มแอป */
export function provideFaIcons(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const registry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    for (const [name, svg] of Object.entries(FA_ICONS)) {
      // SVG มาจากไฟล์ที่ script สร้างใน repo ไม่ใช่ข้อมูลจากผู้ใช้ จึงข้ามการ sanitize ได้
      registry.addSvgIconLiteralInNamespace(
        FA_NAMESPACE,
        name,
        sanitizer.bypassSecurityTrustHtml(svg),
      );
    }
  });
}
